import {
    CREATECHILD_SUCCESS,
    CREATECHILD_FAIL,
    GETCHILD_SUCCESS,
    GETCHILD_FAIL,
    EDITCHILD_SUCCESS,
    EDITCHILD_FAIL,
    DELETECHILD_SUCCESS,
    DELETECHILD_FAIL,
} from "./types";

import ChildService from "../services/child.service"


export const getChilds = (data)=> async(dispatch)=>{
        
    try{
        const res = await ChildService.getChilds(data);
        
        dispatch({
          type: GETCHILD_SUCCESS,
          list: res,
        });
        
        return res
    }catch (error){
        
        dispatch({
            type: GETCHILD_FAIL,
            list: {error: error.response},
          });
          const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          return error.response
    }
}


export const editChild= (form)=>(dispatch)=>{
      
    return ChildService.editChild(form).then(
        (response)=>{
              
            dispatch({
                type:EDITCHILD_SUCCESS,
                item:response
            });
            
            return response

        },
        (error)=>{
            dispatch({
                type: EDITCHILD_FAIL,
              });
            console.log(error);
              return Promise.reject();
        }
    );
}



export const deleteChild= (data)=>(dispatch)=>{
      
    return ChildService.deleteChild(data).then(
        (response)=>{
            dispatch({
                type:DELETECHILD_SUCCESS,
            });
              
        },
        (error)=>{
            dispatch({
                type: DELETECHILD_FAIL,
              });
            console.log(error);
                 
              return Promise.reject();
        }
    );
}





export const addChild = (data)=> async(dispatch)=>{
    try {
        const res = await ChildService.addChild(data);
        dispatch({
          type: CREATECHILD_SUCCESS,
          item: res
        });
        return res
    }catch (error){
        dispatch({
            type: CREATECHILD_FAIL,
            item: {error: error.response},
          });
          const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          return error.response;
    }
}